/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const SERVICE_NAME = "AppNavigatorService.ProfileService";
const log: any = LoggerModule.getInstance();

export interface IUserMethods extends IPluginMethodMap {
  getUserProfile(args: any): Promise<any>;
}

export class UserService implements IAgentPlugin {
  readonly methods: IUserMethods;

  constructor() {
    this.methods = {
      getUserProfile: this.getUserProfile.bind(this),
    };
  }

  async getUserProfile(args: any) {
    //TODO: FIX ME
    return {
      userName: "vlinder Developer",
      userImage:
        "https://ui-avatars.com/api/?name=Vlinder+Developer&background=0D8ABC&color=fff",
    };
  }
}
